module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-2"
    }
  }, [_c('p', {
    staticClass: "noindenttR"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Cover image:")]), _vm._v(" Bombing Up")]), _vm._v(" - Short Stirling "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("by Michael Turner FGAvA (President)")]), _vm._v(" Gouache")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1R"
  }, [_vm._v("Plus thumbnail images from Anthony Cowland FGAvA, Chris French FGAvA, Ron Wong FGAvA, Keith Woodcock FGAvA, Denis Pannett FGAvA, and Frank Wootton OBE FPGAvA")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25066ecf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/002_FM1.vue
// module id = 60
// module chunks = 0